import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import React, { FunctionComponent } from 'react';
import styles from './styles/Popup.css'

interface Props {
    visible?: boolean,
    onDismiss?: (event) => void,
    title?: string,
    subtitle?: string
    utility?: JSX.Element | undefined
}

const Popup: FunctionComponent<Props> = props => {

    const handleDismiss = (event) => {
        props.onDismiss?.(event);
    }

    return (
            <Dialog 
                open={props.visible ?? true}
                onClose={handleDismiss}
                PaperProps={{className: styles.container}}
            >                
              <DialogTitle className={styles.dialogTitle} >{props.title}{props.utility}</DialogTitle>
                <DialogContent className={styles.dialogContent}>
                <DialogContentText>
                    {props.subtitle}
                </DialogContentText>
                    {props.children}
                </DialogContent>
            </Dialog>
    );
}

export default Popup